import React, { FC, PropsWithChildren } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import styles from './styles.module.scss';
import { useLocation } from 'react-router-dom';

const MainLayout: FC<PropsWithChildren> = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <div
      className={
        pathname === '/embroidery-interactive-instruction'
          ? styles.instruction
          : styles.main
      }
    >
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default MainLayout;
